import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import useDepartments from '~/modules/common/enhancers/useDepartments';
import { useAdditionalOptions } from '~/modules/common/hooks';
import { useOptionsMerge } from '~/modules/common/components/SearchAutocomplete';
import { ScopeObjectType } from '~/types';
import { useStyledGroupLabels } from './hooks';
import GroupDropdown from './GroupDropdown';

export const DepartmentDropdown = ({
  classes,
  groupSettings,
  value = '',
  policy,
  onChange,
  enableNoChangeOption = false,
  enableNoValueOption = false,
  scope,
  ...rest
}) => {
  const { formatMessage } = useIntl();
  const [searchTerm, setSearchTerm] = useState('');
  const { department: departmentLabel } = useStyledGroupLabels();
  const { departments, loading, hasMore } = useDepartments({
    searchTerm,
    policy,
    scope
  });
  const additionalOptions = useAdditionalOptions({
    enableNoChangeOption,
    enableNoValueOption,
    noValueMessageId: 'dropdownItem.noDepartment'
  });

  const noGroupsText = groupSettings.singularName
    ? formatMessage(
        { id: 'groupsDropdown.noGroup' },
        { group: groupSettings.singularName }
      )
    : formatMessage({ id: 'departmentDropdown.noDepartment' });

  const options = useOptionsMerge({
    options: departments,
    additionalOptions
  });

  return (
    <GroupDropdown
      hasMore={hasMore}
      classes={classes}
      options={options}
      label={departmentLabel}
      value={value}
      setSearchTerm={setSearchTerm}
      loading={loading}
      noOptionsText={noGroupsText}
      onChange={onChange}
      optionTypeText={formatMessage({
        id: 'moreOptions.department'
      })}
      {...rest}
    />
  );
};

DepartmentDropdown.propTypes = {
  classes: PropTypes.object,
  groupSettings: PropTypes.object,
  onChange: PropTypes.func,
  value: PropTypes.object,
  policy: PropTypes.string,
  enableNoChangeOption: PropTypes.bool,
  enableNoValueOption: PropTypes.bool,
  scope: PropTypes.oneOf(Object.values(ScopeObjectType))
};

export default DepartmentDropdown;
